import { arrayHasItems } from "../../../helpers/common";
import { fmtCompact$ } from "../../../consts/demandplanning";

export const TotalsPoSchedule = ({ totals }) => {
    return (
        <div className="mt-4 grid gap-2 md:grid-cols-2 xl:grid-cols-6">
            {arrayHasItems(totals) &&
                totals.map((total) => (
                    <div className="rounded-md border border-border bg-background px-3 py-2" key={total.label}>
                        <p className="text-[11px] uppercase tracking-[0.12em] text-gray-600">{total.label ?? ""}</p>
                        <p className="mt-1 text-lg font-semibold text-primary">
                            {total.displayValue != null && total.displayValue !== ""
                                ? total.displayValue
                                : total.value
                                  ? fmtCompact$(total.value)
                                  : "$0"}
                        </p>
                    </div>
                ))}
        </div>
    );
};
